import { DraftReturnSchema } from "@redotech/redo-return-operations-common/draft-return/draft-return";
import * as z from "zod";

export const getDraftReturn = {
  name: "getDraftReturn" as const,
  input: z.object({ draftReturnId: z.string() }),
  output: z.object({ draftReturn: DraftReturnSchema.nullish() }),
};
